import { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import ApplicationSkeleton from '~/components/ApplicationSkeleton';

const CircuitCreate = lazy(() => import('~/containers/CircuitCreate'));

export default [
  <Route path="/circuits/new" key="/circuits/new">
    <Suspense fallback={<ApplicationSkeleton />}>
      <CircuitCreate />
    </Suspense>
  </Route>,
];
